import { Converter } from '../types/converter';

export const pressureConverter: Converter = {
  id: 'pressure',
  name: 'Pressure Converter',
  icon: 'ArrowDown',
  categories: ['engineering', 'fluids'],
  units: [
    // SI units and derivatives
    { name: 'Pascal', symbol: 'Pa', factor: 1 },
    { name: 'Exapascal', symbol: 'EPa', factor: 1e18 },
    { name: 'Petapascal', symbol: 'PPa', factor: 1e15 },
    { name: 'Terapascal', symbol: 'TPa', factor: 1e12 },
    { name: 'Gigapascal', symbol: 'GPa', factor: 1e9 },
    { name: 'Megapascal', symbol: 'MPa', factor: 1e6 },
    { name: 'Kilopascal', symbol: 'kPa', factor: 1e3 },
    { name: 'Hectopascal', symbol: 'hPa', factor: 1e2 },
    { name: 'Dekapascal', symbol: 'daPa', factor: 10 },
    { name: 'Decipascal', symbol: 'dPa', factor: 0.1 },
    { name: 'Centipascal', symbol: 'cPa', factor: 0.01 },
    { name: 'Millipascal', symbol: 'mPa', factor: 0.001 },
    { name: 'Micropascal', symbol: 'µPa', factor: 1e-6 },
    { name: 'Nanopascal', symbol: 'nPa', factor: 1e-9 },
    { name: 'Picopascal', symbol: 'pPa', factor: 1e-12 },
    { name: 'Femtopascal', symbol: 'fPa', factor: 1e-15 },
    { name: 'Attopascal', symbol: 'aPa', factor: 1e-18 },

    // Common pressure units
    { name: 'Bar', symbol: 'bar', factor: 1e5 },
    { name: 'Millibar', symbol: 'mbar', factor: 100 },
    { name: 'Microbar', symbol: 'µbar', factor: 0.1 },
    { name: 'Standard atmosphere', symbol: 'atm', factor: 101325 },
    { name: 'Atmosphere technical', symbol: 'at', factor: 98066.5 },
    
    // Force per area units
    { name: 'Newton per square meter', symbol: 'N/m²', factor: 1 },
    { name: 'Newton per square centimeter', symbol: 'N/cm²', factor: 1e4 },
    { name: 'Newton per square millimeter', symbol: 'N/mm²', factor: 1e6 },
    { name: 'Kilonewton per square meter', symbol: 'kN/m²', factor: 1000 },
    { name: 'Dyne per square centimeter', symbol: 'dyne/cm²', factor: 0.1 },
    
    // PSI units
    { name: 'Pounds per square inch', symbol: 'psi', factor: 6894.757293168 },
    { name: 'Kilopounds per square inch', symbol: 'ksi', factor: 6894757.293168 },
    { name: 'Pound-force per square inch', symbol: 'lbf/in²', factor: 6894.757293168 },
    { name: 'Pound-force per square foot', symbol: 'lbf/ft²', factor: 47.88025898 },
    { name: 'Poundal per square foot', symbol: 'pdl/ft²', factor: 1.488164 },
    { name: 'Kip-force per square inch', symbol: 'kipf/in²', factor: 6894757.293168 },
    
    // Ton-force units
    { name: 'Ton-force (short) per square foot', symbol: 'tonf (short)/ft²', factor: 95760.517960 },
    { name: 'Ton-force (short) per square inch', symbol: 'tonf (short)/in²', factor: 13789514.586 },
    { name: 'Ton-force (long) per square foot', symbol: 'tonf (long)/ft²', factor: 107251.780115 },
    { name: 'Ton-force (long) per square inch', symbol: 'tonf (long)/in²', factor: 15444256.337 },
    
    // Kilogram-force units
    { name: 'Kilogram-force per square meter', symbol: 'kgf/m²', factor: 9.80665 },
    { name: 'Kilogram-force per square centimeter', symbol: 'kgf/cm²', factor: 98066.5 },
    { name: 'Kilogram-force per square millimeter', symbol: 'kgf/mm²', factor: 9806650 },
    { name: 'Gram-force per square centimeter', symbol: 'gf/cm²', factor: 98.0665 },
    
    // Mercury units
    { name: 'Torr', symbol: 'Torr', factor: 133.3223684 },
    { name: 'Centimeter of mercury (0°C)', symbol: 'cmHg', factor: 1333.223684 },
    { name: 'Millimeter of mercury (0°C)', symbol: 'mmHg', factor: 133.3223684 },
    { name: 'Inch of mercury (32°F)', symbol: 'inHg', factor: 3386.388640341 },
    { name: 'Inch of mercury (60°F)', symbol: 'inHg (60°F)', factor: 3376.85 },
    
    // Water column units
    { name: 'Centimeter of water (4°C)', symbol: 'cmH₂O', factor: 98.0638 },
    { name: 'Millimeter of water (4°C)', symbol: 'mmH₂O', factor: 9.80638 },
    { name: 'Inch of water (4°C)', symbol: 'inH₂O', factor: 249.08891 },
    { name: 'Foot of water (4°C)', symbol: 'ftH₂O', factor: 2989.06692 },
    { name: 'Inch of water (60°F)', symbol: 'inH₂O (60°F)', factor: 248.84 },
    { name: 'Foot of water (60°F)', symbol: 'ftH₂O (60°F)', factor: 2986.08 }
  ]
};
